

export class RoutePathOutputWithStatus implements IRoutePathOutputWithStatus {
    /** The auto-generated id of the route path master */
    route_path_id!: number;
    /** The company name with 255 character limit */
    company_name!: string;
    /** The branch name with 255 character limit */
    branch!: string;
    /** The path name with 255 character limit */
    path_name!: string;
    /** The start point with 5000 character limit */
    start_point!: string;
    /** The start point with 5000 character limit */
    end_point!: string;
    /** Manage status of  route path. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IRoutePathOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.route_path_id = _data["route_path_id"];
            this.company_name = _data["company_name"];
            this.branch = _data["branch"];
            this.path_name = _data["path_name"];
            this.start_point = _data["start_point"];
            this.end_point = _data["end_point"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): RoutePathOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new RoutePathOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["route_path_id"] = this.route_path_id;
        data["company_name"] = this.company_name;
        data["branch"] = this.branch;
        data["path_name"] = this.path_name;
        data["start_point"] = this.start_point;
        data["end_point"] = this.end_point;
        data["status"] = this.status;
        return data; 
    }
}

export interface IRoutePathOutputWithStatus {
    /** The auto-generated id of the route path master */
    route_path_id: number;
    /** The company name with 255 character limit */
    company_name: string;
    /** The branch name with 255 character limit */
    branch: string;
    /** The path name with 255 character limit */
    path_name: string;
    /** The start point with 5000 character limit */
    start_point: string;
    /** The start point with 5000 character limit */
    end_point: string;
    /** Manage status of  route path. 0 For De-active, 1 For Active */
    status: number;
}

